import React, { lazy, Suspense } from 'react';
export var ASSETS_LIST_OF_LINKS_DATASOURCE_ID = '361d618a-3c04-40ad-9b27-3c8ea6927020';
var LazyAssetsConfigModal = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_linkdatasource-assetsmodal" */'./modal').then(function (module) {
    return {
      default: module.AssetsConfigModal
    };
  });
});
var AssetsConfigModalWithWrappers = function AssetsConfigModalWithWrappers(props) {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement("div", {
      "data-testid": 'assets-aql-datasource-table-suspense'
    })
  }, /*#__PURE__*/React.createElement(LazyAssetsConfigModal, props));
};
export default AssetsConfigModalWithWrappers;